import React, { useState } from "react";
import { BsChevronDown } from "react-icons/bs";
import { BsChevronUp } from "react-icons/bs";

const FAQ = () => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [open5, setOpen5] = useState(false);
  const [open6, setOpen6] = useState(false);
  return (
    <div className="bg-gradient-to-tl from-[#212445] via-[#212445] to-[#462E52]">
      <h1 className="text-4xl md:text-5xl font-bold text-white  md:px-28 px-4 ">
        FAQs
      </h1>
      <div className="py-10">
        <div className=" mx-auto lg:px-72 px-4 ">
          <div
            className="flex bg-gradient-to-r py-3 px-6 rounded-xl  from-[#2C55B9] to-[#8B53E8] hover:cursor-pointer"
            onClick={() => setOpen(!open)}
          >
            <h1 className="text-xl  text-white">
              As a recipient of a box, how can I access its contents?{" "}
            </h1>

            {open === true ? (
              <BsChevronUp
                onClick={() => setOpen(false)}
                color="white"
                className="ml-auto my-auto hover:cursor-pointer"
              />
            ) : (
              <BsChevronDown
                onClick={() => setOpen(true)}
                color="white"
                className="ml-auto my-auto hover:cursor-pointer"
              />
            )}
          </div>

          {open && (
            <p className="text-[#9EA0A1] text-justify text-xl p-4">
              If you have received an email from a box sender, you must first use
              the unique link provided in the email to register with Clowds.io.
              We recommend you reach out to the box sender to understand whether
              their wishes are for you to be granted access while they’re still
              alive or deceased as this will dictate when you should be
              requesting access to the box (when ready, click “Unlock Box”
              within your Recipient portal).{" "}
            </p>
          )}
        </div>

        <div className=" mx-auto lg:px-72 px-4 py-4">
          <div
            className="flex bg-gradient-to-r py-3 px-6 rounded-xl  from-[#2C55B9] to-[#8B53E8] hover:cursor-pointer"
            onClick={() => setOpen2(!open2)}
          >
            <h1 className="text-xl text-white">
              Once I verify that the box sender has passed, how do I access my
              box?{" "}
            </h1>
            {open2 === true ? (
              <BsChevronUp
                onClick={() => setOpen2(false)}
                color="white"
                className="ml-auto my-auto hover:cursor-pointer"
              />
            ) : (
              <BsChevronDown
                onClick={() => setOpen2(true)}
                color="white"
                className="ml-auto my-auto hover:cursor-pointer"
              />
            )}
          </div>

          {open2 && (
            <p className="text-[#9EA0A1] text-justify text-xl p-4">
              Recipients can log into their Clowds.io account where they will
              see the boxes they’ve been sent, along with an “Unlock Box” button
              to initiate the request. The box sender will receive a request to
              approve or deny the request within the next 14 days. If they have
              passed, recipients must still wait 14 days at which point they
              will be asked to request access once more from the “Unlock Box”
              and wait 14 days. After the 14 days, the box will automatically be
              unlocked.
            </p>
          )}
        </div>

        <div className=" mx-auto lg:px-72 px-4">
          <div
            className="flex bg-gradient-to-r py-3 px-6 rounded-xl  from-[#2C55B9] to-[#8B53E8] hover:cursor-pointer"
            onClick={() => setOpen3(!open3)}
          >
            <h1 className="text-xl text-white">
              How many incorrect attempts will I have to access my box before I
              lose complete access?{" "}
            </h1>
            {open3 === true ? (
              <BsChevronUp
                onClick={() => setOpen3(false)}
                color="white"
                className="ml-auto my-auto hover:cursor-pointer"
              />
            ) : (
              <BsChevronDown
                onClick={() => setOpen3(true)}
                color="white"
                className="ml-auto my-auto hover:cursor-pointer"
              />
            )}
          </div>

          {open3 && (
            <p className="text-[#9EA0A1] text-justify text-xl p-4">
              Recipients are given 3 incorrect tries (you must wait 14 days
              between each incorrect attempt whereby if the sender is still
              living and denies your request) after which point you are locked
              out of the box forever. It’s best to wait to unlock the box until
              after you’re aware of their passing.
            </p>
          )}
        </div>

        <div className=" mx-auto lg:px-72 px-4 py-4">
          <div
            className="flex bg-gradient-to-r py-3 px-6 rounded-xl  from-[#2C55B9] to-[#8B53E8] hover:cursor-pointer"
            onClick={() => setOpen4(!open4)}
          >
            <h1 className="text-xl text-white">
              What type of files can be uploaded to my box?{" "}
            </h1>
            {open4 === true ? (
              <BsChevronUp
                onClick={() => setOpen4(false)}
                color="white"
                className="ml-auto my-auto hover:cursor-pointer"
              />
            ) : (
              <BsChevronDown
                onClick={() => setOpen4(true)}
                color="white"
                className="ml-auto my-auto hover:cursor-pointer"
              />
            )}
          </div>

          {open4 && (
            <p className="text-[#9EA0A1] text-justify text-xl p-4">
              You can upload standard filetype documents, like Word docs, PDFs,
              Excel, PowerPoints, as well as media filetypes, like .mov, jpeg,
              ti , gif.{" "}
            </p>
          )}
        </div>

        <div className=" mx-auto lg:px-72 px-4">
          <div
            className="flex bg-gradient-to-r py-3 px-6 rounded-xl  from-[#2C55B9] to-[#8B53E8] hover:cursor-pointer"
            onClick={() => setOpen5(!open5)}
          >
            <h1 className="text-xl text-white">
              What should not be uploaded to my box?
            </h1>
            {open5 === true ? (
              <BsChevronUp
                onClick={() => setOpen5(false)}
                color="white"
                className="ml-auto my-auto hover:cursor-pointer"
              />
            ) : (
              <BsChevronDown
                onClick={() => setOpen5(true)}
                color="white"
                className="ml-auto my-auto hover:cursor-pointer"
              />
            )}
          </div>

          {open5 && (
            <p className="text-[#9EA0A1] text-justify text-xl p-4">
              Although files on Clowds.io are encrypted and secure, we do not
              recommend uploading any highly confidential usernames and passwords
              you do not want sharing with recipients now or in the future. This
              is to prevent undesired logins from recipients in the event you
              accidentally unlock your box. While we will endeavor to resolve
              any issues, Clowds.io is not liable for any data breaches or
              errors in boxes sent or received or issues with accessibility.{" "}
            </p>
          )}
        </div>

        <div className=" mx-auto lg:px-72 px-4 py-4">
          <div
            className="flex bg-gradient-to-r px-6 py-3 rounded-xl  from-[#2C55B9] to-[#8B53E8] hover:cursor-pointer"
            onClick={() => setOpen6(!open6)}
          >
            <h1 className="text-xl text-white">
              What happens to my box in perpetuity?{" "}
            </h1>
            {open6 === true ? (
              <BsChevronUp
                onClick={() => setOpen6(false)}
                color="white"
                className="ml-auto my-auto hover:cursor-pointer"
              />
            ) : (
              <BsChevronDown
                onClick={() => setOpen6(true)}
                color="white"
                className="ml-auto my-auto hover:cursor-pointer"
              />
            )}
          </div>

          {open6 && (
            <p className="text-[#9EA0A1] text-justify text-xl p-4">
              Boxes will be accessible for as long as Clowds.io is in service.
              While we do not expect anything to change, Clowds.io will endeavor
              that all boxes are unlocked and les are accessible for recipients
              before any major changes to the platform occurs.{" "}
            </p>
          )}
        </div>
      </div>
      <img
        src="https://themegenix.net/wp/nerko/wp-content/uploads/2022/12/divider-01.svg"
        className="mx-auto py-10"
      />
    </div>
  );
};

export default FAQ;
